import { signOut } from 'next-auth/react';
import { useCallback } from 'react';
import { clearSelectedOrganisation } from '@/utils/storage';
import { PUBLIC_ROUTES } from '@/configs/routes';

export function useLogout() {
  const logout = useCallback(async () => {
    try {
      clearSelectedOrganisation();
      sessionStorage.clear();
      localStorage.removeItem('selectedOrganisationId');
      await signOut({ callbackUrl: PUBLIC_ROUTES.HOME });
    } catch (error) {
      console.error('[Auth] Logout error:', error);
      window.location.href = PUBLIC_ROUTES.HOME;
    }
  }, []);

  return { logout };
}
